import { reportTxt } from "../../../../../assets/texts/CloudAnalytics";
import { DRAWER_COMPONENTS } from "../constants";
import { useDrawerStore } from "../hooks/useDrawerStore";

export const DrawerContent = () => {
  const { type } = useDrawerStore();

  if (!type) return null;

  const Component = DRAWER_COMPONENTS[type];

  if (!Component) {
    return <div className="p-6">{reportTxt.QUICK_VIEW_DRAWER_ERROR}</div>;
  }

  return <Component />;
};
